export const thumbnailUri = (thumbnail) =>
  `${process.env.REACT_APP_API_SERVER}/api/thumbnail/${
    thumbnail || "placeholder-square.jpg"
  }`;
